import { render, staticRenderFns } from "./UiDatePicker.vue?vue&type=template&id=67db06bc&"
import script from "./UiDatePicker.vue?vue&type=script&lang=js&"
export * from "./UiDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports